import { Module } from 'vuex';

export type UserDocumentNotificationState = {
  hasNotification: boolean;
  notificationType?: 'usage_exceeded' | 'contract_expired';
};

export const initialUserDocumentNotificationState: UserDocumentNotificationState =
  {
    hasNotification: false,
    notificationType: undefined,
  };

const userDocumentNotification: Module<UserDocumentNotificationState, unknown> =
  {
    namespaced: true,
    state: () => initialUserDocumentNotificationState,
    mutations: {
      setHasNotification(state, hasNotification: boolean) {
        state.hasNotification = hasNotification;
      },
      setNotificationType(
        state,
        notificationType: 'usage_exceeded' | 'contract_expired' | undefined,
      ) {
        state.notificationType = notificationType;
      },
    },
  };

export default userDocumentNotification;
